import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getAllOrganizations = () => {
  return dispatch => {
    dispatch({ type: "GET_ORGANIZATIONS_LOADING" });
    api
      .organizationsGetAll()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchOrganizationsAlertTitle",
          "Virhe yritystietojen noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ORGANIZATIONS_SUCCEEDED",
  payload: { organizations: data },
});

const operationFail = () => ({
  type: "GET_ORGANIZATIONS_FAIL"
});


export const selectOrganization = data => ({
  type: "SELECT_ORGANIZATION",
  payload: { selectedOrganization: data },
});
